import { rmaNavigationState } from '@/entities/rma';
import { DeviceInfoDrawer } from '@/entities/device';
import { DevicesTable } from '@/widgets/devices-table';
import { SearchIconV2 } from '@/shared/ui/assets';
import { DEVICE_TABLE_TYPE } from '@/shared/config';
import { CustomInput } from '@/shared/ui/components';
import classNames from 'classnames';
import { t } from 'ttag';
import { useDevicesMaintenanceTable } from './useDevicesMaintenanceTable';
import type { DevicesMaintenanceTableProps } from './devicesMaintenanceTable.types';

const DevicesMaintenanceTable = ({
  isActive,
  selectedFacility,
  supportFacilities,
}: DevicesMaintenanceTableProps) => {
  const { state, toggleDisplayDrawer, onChangeSearchValue } = useDevicesMaintenanceTable();

  // const hasWarning = !props.isFacilitySubscribeProtectPlus;

  return (
    <>
      <DeviceInfoDrawer
        visible={state.isVisibleDeviceInfoDrawer}
        deviceId={state.clickedDevice?.deviceId ?? ''}
        handleClickCloseButton={() => {
          toggleDisplayDrawer();
        }}
      />

      <div className="device-maintenance-wrapper">
        {/* {
          hasWarning && (
            <div className="warning-protect-plus">
              <img src={warningIcon} alt="icon warning" />
              {t`Without our Protect+ Program, you will be charged $100 per device replacement. Please contact your sales representative to learn more about Protect+ Program.`}
            </div>
          )
        } */}

        <div
          className={classNames(
            'device-maintenance',
            // hasWarning && '--has-warning',
          )}
        >
          <div className="device-maintenance-search-row">
            <CustomInput
              id="device-search-input"
              aria-label={t`Search by Device ID`}
              style={{ width: 300 }}
              name="searchValue"
              type="number"
              className="device-maintenance-search-input"
              onChange={onChangeSearchValue}
              value={state.searchValue}
              placeholder={t`Search by Device ID`}
              size="middle"
              suffix={<img src={SearchIconV2} alt="Search Icon" />}
              allowClear
            />
          </div>

          <DevicesTable
            isActive={isActive}
            type={DEVICE_TABLE_TYPE.MAINTENANCE}
            toggleDisplayDrawer={toggleDisplayDrawer}
            searchValue={state.searchValue}
            searchByValue="deviceId"
            searchGoto={rmaNavigationState.maintenance.search}
            selectedFacility={selectedFacility}
            supportFacilities={supportFacilities}
            selectGoto={rmaNavigationState.maintenance.select}
            model={state.model}
          />
        </div>
      </div>
    </>
  );
};

export default DevicesMaintenanceTable;
